"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rehydratedReducer = void 0;
var rehydrateComplete_1 = require("./actions/rehydrateComplete");
var logout_1 = require("../logout");
var rehydratedReducer = function (state, action) {
    if (state === void 0) { state = false; }
    switch (action.type) {
        case rehydrateComplete_1.REHYDRATE_COMPLETE.ACTION:
        case logout_1.LOGOUT.ACTION:
            return true;
        default:
            return state;
    }
};
exports.rehydratedReducer = rehydratedReducer;
//# sourceMappingURL=rehydrated.reducer.js.map